const iconStyle = {
    size: '20px',
    color: '#425EF4',
    colorActive: '#ffffff'
}

export { iconStyle }